(function () {
  function initAnnouncement() {
    document.querySelectorAll('[data-mb-hdr-announce]').forEach(function (bar) {
      var track = bar.querySelector('[data-mb-hdr-ann-slides]');
      var slideCount = track ? track.children.length : 0;
      if (!slideCount) return;

      var i = 0;
      function go(n) {
        i = (n + slideCount) % slideCount;
        track.style.transform = 'translateX(-' + i * 100 + '%)';
      }
      var prev = bar.querySelector('[data-mb-hdr-ann-prev]');
      var next = bar.querySelector('[data-mb-hdr-ann-next]');
      if (prev) prev.addEventListener('click', function () { go(i - 1); });
      if (next) next.addEventListener('click', function () { go(i + 1); });
    });
  }

  // Sticky header + compact mode + (mobile) collapsible context bar. The
  // header goes position:fixed (via .mb-hdr--pinned) once scrolled past
  // the announcement bar, with .mb-hdr__spacer sized to match so the rest
  // of the page doesn't jump underneath it — plain CSS position:sticky
  // can't be used here since the header's wrapping div has no extra
  // height below it to "stick" within.
  //
  // On mobile, scrolling further DOWN past the pin threshold also swaps
  // the full header for the slim .mb-hdr__context bar (back arrow +
  // page title); scrolling UP swaps it back. This only ever activates
  // once pinned, so it never fights with the initial pin transition.
  // The context-bar CSS (and the rule that hides the full header while
  // it's showing) only exists inside the max-width:760px media query, so
  // this is guarded by the same breakpoint here too — without this check,
  // toggling .mb-hdr--context-visible above that width would still ADD
  // the class (harmless on its own) but any future CSS mistake targeting
  // it outside the media query would hide the header with nothing to
  // replace it, which is exactly the "header vanishes on scroll" bug this
  // guards against defensively, on top of the CSS itself being fixed.
  //
  // Scroll source: at narrower/mobile widths this theme's base styles
  // leave body/html scrollable, so window scroll works. At wider desktop
  // widths those same base styles switch body/html to overflow:hidden and
  // make .page-wrapper (an ancestor a few levels up from the header) the
  // actual scrolling element instead — window.scrollY then never changes
  // no matter how far the visitor scrolls. So we listen on both and use
  // whichever one is actually moving.
  //
  // Mobile-only flicker fix: mobile browsers report noisy/bouncy scrollY
  // values that desktop mouse-wheel scrolling never produces — iOS
  // Safari's collapsing address bar shifts scrollY by tens of pixels with
  // no real user scroll intent, and momentum/rubber-band scrolling can
  // overshoot and settle back within a couple of frames. Since the
  // context-bar swap used a small fixed 6px direction threshold with no
  // time component, that noise could flip contextVisible true/false
  // several times within a fraction of a second — each flip is an instant
  // (non-gradual) show/hide of two different bars, so rapid flips read as
  // the header "blinking". This never showed up on desktop because this
  // whole contextVisible branch is gated to `contextQuery.matches` (only
  // active below the 760px breakpoint) — the shared pin/shrink logic
  // above it is untouched here. Fix: once contextVisible flips, ignore
  // further flips for contextToggleLockMs — real scroll reversals take
  // far longer than that to register, while a bogus toolbar/bounce jump
  // resolves within a frame or two.
  function initShrink() {
    var contextQuery = window.matchMedia('(max-width: 760px)');
    var contextToggleLockMs = 220;

    document.querySelectorAll('[data-mb-hdr-site]').forEach(function (site) {
      if (!site.classList.contains('mb-hdr--sticky')) return;

      var wrap = site.closest('.mb-header-wrap');
      var announce = wrap ? wrap.querySelector('[data-mb-hdr-announce]') : null;
      var spacer = wrap ? wrap.querySelector('[data-mb-hdr-spacer]') : null;
      var context = wrap ? wrap.querySelector('[data-mb-hdr-context]') : null;
      var pageScroller = document.querySelector('.page-wrapper');
      var ticking = false;
      var lastScrollY = 0;
      var contextVisible = false;
      var lastContextToggleAt = 0;

      function currentScrollY() {
        var winY = window.scrollY || document.documentElement.scrollTop || 0;
        var pwY = pageScroller ? pageScroller.scrollTop : 0;
        return Math.max(winY, pwY);
      }

      function update() {
        ticking = false;
        var announceHeight = announce ? announce.offsetHeight : 0;
        var scrollY = currentScrollY();
        var shouldPin = scrollY > announceHeight;

        site.classList.toggle('mb-hdr--shrink', scrollY > 80);
        site.classList.toggle('mb-hdr--pinned', shouldPin);

        if (context && contextQuery.matches) {
          var now = Date.now();
          if (!shouldPin) {
            // Deterministic on scroll position alone (not a direction-based
            // flip), so this is always safe to apply immediately.
            contextVisible = false;
          } else if (now - lastContextToggleAt >= contextToggleLockMs) {
            if (scrollY > lastScrollY + 6 && scrollY > 70 && !contextVisible) {
              contextVisible = true;
              lastContextToggleAt = now;
            } else if ((scrollY < lastScrollY - 6 || scrollY <= 4) && contextVisible) {
              contextVisible = false;
              lastContextToggleAt = now;
            }
          }
        } else {
          contextVisible = false;
        }
        if (context) context.classList.toggle('is-visible', contextVisible);
        site.classList.toggle('mb-hdr--context-visible', contextVisible);

        if (spacer) {
          if (!shouldPin) {
            spacer.style.height = '0px';
          } else if (context && contextVisible) {
            spacer.style.height = context.offsetHeight + 'px';
          } else {
            spacer.style.height = site.offsetHeight + 'px';
          }
        }

        lastScrollY = scrollY;
      }

      function onScroll() {
        if (!ticking) { ticking = true; requestAnimationFrame(update); }
      }

      window.addEventListener('scroll', onScroll, { passive: true });
      if (pageScroller) pageScroller.addEventListener('scroll', onScroll, { passive: true });
      contextQuery.addEventListener('change', onScroll);

      update();
    });
  }

  // Back button on the mobile context bar: prefer real browser back
  // (matches the native-app feel) when there's history to go back to,
  // otherwise fall back to the link's own href (home).
  function initContextBack() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-mb-hdr-context-back]');
      if (!btn) return;
      if (window.history.length > 1) {
        e.preventDefault();
        window.history.back();
      }
    });
  }

  function escapeHtml(str) {
    return (str || '').replace(/[&<>"']/g, function (c) {
      return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c];
    });
  }

  function initSearch() {
    document.querySelectorAll('[data-mb-hdr-search]').forEach(function (wrap) {
      var input = wrap.querySelector('[data-mb-hdr-search-input]');
      var ac = wrap.querySelector('[data-mb-hdr-ac]');
      if (!input || !ac) return;

      var debounceTimer = null;

      input.addEventListener('input', function () {
        var query = input.value.trim();
        if (debounceTimer) clearTimeout(debounceTimer);

        if (query.length < 2) {
          wrap.classList.remove('mb-hdr--ac-open');
          return;
        }

        debounceTimer = setTimeout(function () {
          fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][fields]=title,vendor,product_type')
            .then(function (res) { return res.json(); })
            .then(function (data) {
              var products = (data.resources && data.resources.results && data.resources.results.products) || [];
              if (!products.length) {
                ac.innerHTML = '<div class="mb-hdr__ac-empty">No results for "' + escapeHtml(query) + '"</div>';
              } else {
                ac.innerHTML = products.map(function (p) {
                  var img = p.featured_image ? p.featured_image.url : (p.image || '');
                  return (
                    '<a class="mb-hdr__ac-row" href="' + p.url + '">' +
                      (img ? '<img src="' + img + '" alt="" loading="lazy">' : '') +
                      '<div class="mb-hdr__ac-info">' +
                        '<div class="mb-hdr__ac-t">' + escapeHtml(p.title) + '</div>' +
                        (p.vendor ? '<div class="mb-hdr__ac-a">' + escapeHtml(p.vendor) + '</div>' : '') +
                      '</div>' +
                      '<div class="mb-hdr__ac-pr">' + (p.price || '') + '</div>' +
                    '</a>'
                  );
                }).join('') +
                '<a class="mb-hdr__ac-foot" href="/search?q=' + encodeURIComponent(query) + '&type=product">See all results for "' + escapeHtml(query) + '"</a>';
              }
              wrap.classList.add('mb-hdr--ac-open');
            })
            .catch(function () { wrap.classList.remove('mb-hdr--ac-open'); });
        }, 220);
      });

      document.addEventListener('click', function (e) {
        if (!wrap.contains(e.target)) wrap.classList.remove('mb-hdr--ac-open');
      });
    });
  }

  // Touch/click fallback for mega menus (CSS handles hover for pointer devices).
  function initMegaTouch() {
    document.querySelectorAll('.mb-hdr__navitem').forEach(function (item) {
      var link = item.querySelector(':scope > .mb-hdr__navlink');
      if (!link) return;

      link.addEventListener('click', function (e) {
        if (window.matchMedia('(hover: hover)').matches) return; // let hover/CSS handle desktop
        e.preventDefault();
        var isOpen = item.classList.contains('mb-hdr--nav-open');
        document.querySelectorAll('.mb-hdr__navitem.mb-hdr--nav-open').forEach(function (el) {
          el.classList.remove('mb-hdr--nav-open');
        });
        if (!isOpen) item.classList.add('mb-hdr--nav-open');
      });
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.mb-hdr__navitem')) {
        document.querySelectorAll('.mb-hdr__navitem.mb-hdr--nav-open').forEach(function (el) {
          el.classList.remove('mb-hdr--nav-open');
        });
      }
    });
  }

  // Mobile hamburger nav drawer (mecca-mobile-nav-drawer.liquid). The
  // desktop mega-menu markup stays hidden on mobile; this is a separate,
  // simple accordion drawer that reuses the same assigned Navigation menu.
  function initMobileNav() {
    var root = document.querySelector('[data-mb-navd-root]');
    if (!root) return;

    function open() {
      root.classList.add('is-open');
      document.body.classList.add('mb-navd-lock');
      var panel = root.querySelector('.mb-navd__panel');
      if (panel) panel.focus();
    }
    function close() {
      root.classList.remove('is-open');
      document.body.classList.remove('mb-navd-lock');
    }

    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-mb-hdr-menu-open]')) { open(); return; }
      if (e.target.closest('[data-mb-hdr-menu-close]')) { close(); return; }

      var toggle = e.target.closest('[data-mb-navd-toggle]');
      if (toggle) {
        e.preventDefault();
        e.stopPropagation();
        var item = toggle.closest('.mb-navd__item');
        if (item) item.classList.toggle('is-open');
        return;
      }
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && root.classList.contains('is-open')) close();
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncement();
    initShrink();
    initContextBack();
    initSearch();
    initMegaTouch();
    initMobileNav();
  });
})();